<template>
    <div>
        <v-dialog
            v-model="display"
            width="1150"
            persistent>
            <v-card flat>
                <v-card-title>
                    {{ title }}
                    <v-spacer></v-spacer>
                    <!-- <v-switch v-if="notEditMode" label="SMS" v-model="form.send_sms"></v-switch> -->
                    <v-menu
                        offset-y>
                        <template v-slot:activator="{on}">
                            <v-btn
                                icon
                                v-on="on"
                                class="mx-1">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list width="250" dense>
                            <v-list-item
                                @click="openSalesOrderItemLineDialog({ editMode: false })"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-database-plus</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('new_item_line') }}</v-list-item-title>
                            </v-list-item> 
                            <v-list-item
                                v-if="selected.salesOrderLineItem.length == 1"
                                @click="openSalesOrderItemLineDialog({ editMode: true, items: selected.salesOrderLineItem[0] })"
                                link
                                >
                                <v-list-item-icon>
                                    <v-icon >mdi-pencil</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('edit_item_line') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="selected.salesOrderLineItem.length"
                                @click="deleteItemLine(selected.salesOrderLineItem[0])"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('delete_item_line') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-row>
                            <v-col cols="4">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        hide-details="auto"
                                        v-model="form.date"
                                        :rules="rules.date"
                                        :disabled="uneditableField('date')"
                                        :label="$t('date')"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker @change="form.validity_date = form.date" v-model="form.date" @input="menu = false" no-title scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4">
                                <v-menu
                                    ref="menuValidity"
                                    v-model="menuValidity"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        hide-details="auto"
                                        v-model="form.validity_date"
                                        :rules="rules.validity_date"
                                        :disabled="uneditableField('validity_date')"
                                        :label="$t('validity_date')"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker :min="form.date" v-model="form.validity_date" @input="menuValidity = false" no-title scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <!-- <v-text-field
                                    dense
                                    autofocus
                                    hide-details="auto"
                                    :append-icon="form.customer_id ? '' : 'mdi-magnify'"
                                    :readonly="!!form.customer_id"
                                    :clearable="true"
                                    @click:clear="form.customer_id = null"
                                    @keypress.enter="openCustomerSearchDialog"
                                    @blur="!form.customer_id ? form.customer = null : null"
                                    v-model="form.customer"
                                    :rules="rules.customer"
                                    :disabled="uneditableField('customer_id')"
                                    :label="$t('customer')">
                                </v-text-field> -->
                                <!-- <p-customer-search 
                                    v-model="form.customer_id"
                                    :rules="rules.customer"
                                    @update:name="setCustomerName">
                                </p-customer-search> -->
                                <customer-search
                                    :label="$t('customer')"
                                    item-text="display_name"
                                    v-model="form.customer_id"
                                    :rules="rules.customer">
                                </customer-search>
                            </v-col>
                        </v-row>
                        <v-data-table
                            disable-pagination
                            hide-default-footer
                            dense
                            show-select
                            single-select
                            item-key="row_id"
                            :items="form.sales_order_item_lines"
                            v-model="selected.salesOrderLineItem"
                            :headers="headers.salesOrderLineItem">
                            <template v-slot:[`item.tax`]="{item}">
                                {{ formatNumber(item.tax) }}
                            </template>
                            <template v-slot:[`item.total`]="{item}">
                                {{ formatCurrency(item.total) }}
                            </template>
                            <template v-slot:[`item.subtotal`]="{item}">
                                {{ formatNumber(item.subtotal) }}
                            </template>
                            <template v-slot:[`item.quantity`]="{item}">
                                {{ formatNumber(item.quantity)}} {{item.measure_unit}}
                            </template>
                            <template v-slot:[`item.price`]="{item}">
                                {{ formatNumber(item.price) }}
                            </template>
                            <template slot="body.append">
                                <tr>
                                    <td colspan="6"></td>
                                    <td><b>{{ $t('sub_total') }}</b></td>
                                    <td><b>{{ subtotal }}</b></td>
                                </tr>
                                <tr>
                                    <td colspan="6"></td>
                                    <td>{{ $t('tax') }}</td>
                                    <td>{{ tax }}</td>
                                </tr>
                                <tr>
                                    <td colspan="6"></td>
                                    <td><b>{{ $t('total') }}</b></td>
                                    <td><b>{{ total }}</b></td>
                                </tr>
                            </template>
                        </v-data-table>
                        <!-- <v-divider class="my-4"></v-divider> -->
                        <v-textarea
                            outlined
                            hide-details
                            rows="2"
                            :label="$t('note')"
                            v-model="form.notes">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="loading.data || !valid || loading.submit || !form.sales_order_item_lines.length"
                        :loading="loading.submit"
                        @click="submit"
                        >
                        {{ $t("save_btn" )}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="attemptClose">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog
            ref="alertDialog"/>
        <CustomerSearchDialog
            @store="fetchCustomerName"
            ref="customerSearchDialog"/>
        <SalesOrderItemLineDialog
            @store="lineHandler"
            ref="salesOrderItemLineDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="decisionDialogHandler"/>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { formatMoney, formatNumber } from 'accounting';
import moment from 'moment';
import {random, isNull, findIndex} from 'lodash';

import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';
import uneditableField from '@/utils/uneditableField';
import SalesOrderItemLineDialog from '@/components/Sales/SalesOrderItemLineDialog'
import CustomerSearchDialog from '@/components/Sales/CustomerSearchDialog';
import DecisionDialog from '@/components/common/DecisionDialog';
import CustomerSearch from '../searchComponents/CustomerSearch.vue';

import { getCustomer } from '../../services/sales/customer';

export default {
    name: "SalesOrderDialog",
    components: {
        RetryDialog,
        AlertDialog,
        CustomerSearchDialog,    
        SalesOrderItemLineDialog,
        DecisionDialog,
        CustomerSearch
    },
    data() {
        return {
            taxPercentage: 17,
            tax: 0,
            subtotal: 0,
            total: 0,
            date_min: null,
            date_max: null,
            display: false,
            openParams: null,
            valid: false,
            menuValidity: false,
            menu: false,
            mode: {
                edit: false
            },
            loading: {
                data: false,
                submit: false
            },
            form: {
                id: null,
                date: null,
                validity_date: null,
                customer_id: null,
                customer: null,
                notes: null,
                sales_order_item_lines: [],
                send_sms: false
            },
            rules: {
                date: [
                    v => !!v || this.$t("rules_required")
                ],
                validity_date: [
                    v => !!v || this.$t("rules_required")
                ],
                customer: [
                    v => !!v || this.$t("rules_required")
                ]
            },
            selected: {
                salesOrderLineItem: []
            },
            headers: {
                salesOrderLineItem: [
                    { text: this.$t('item'), value: "item" },
                    { text: this.$t('type'), value: "cast_type" },
                    { text: this.$t('quantity'), value: "quantity" },
                    { text: this.$t('price'), value: "price" },
                    { text: this.$t('sub_total'), value: "subtotal" },
                    { text: this.$t('tax'), value: "tax" },
                    { text: this.$t('total'), value: "total" }
                ]
            }
            
        }
    },
    computed: {
        ...mapState("sales/salesOrder", ["salesOrder"]),
        ...mapState("sales/customer", ["customerSearch"]),
        title() {
            if(!this.mode.edit) return this.$t('new_sales_order')
            else return this.$t('edit_sales_order')
        },
        editMode() {
            return this.mode.edit;
        },
        notEditMode() {
            return !this.editMode;
        }
    },
    watch: {
        "form.sales_order_item_lines": {
            handler() {
                this.calculateLineTotals();
                this.calculateTotals();
            },
            deep: true
        }
    },
    methods: {
        formatNumber,
        uneditableField,
        ...mapActions("sales/salesOrder", ["fetchSalesOrders", "fetchSalesOrder", "storeSalesOrder", "updateSalesOrder"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        ...mapActions("sales/dpk", ["fetchDpk"]),
        ...mapActions("sales/customer", ["setCustomersFromSearch"]),
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.form.dpk = dpk.key;
        },
        customerExistInStore(customerId) {
            return this.customerSearch.indexOf(this.customerSearch.find(each => each.id == customerId)) === -1 ? false : true ;
        },
        getCustomerData(customerId) {
            // if customer is not available in store fire http request and set it in the store.
            if(this.customerExistInStore(customerId)) return;
            getCustomer(customerId).then(response => this.setCustomersFromSearch([response.data]));
        },
        getTotalOf(field) {
            return this.form.sales_order_item_lines.reduce((total, line) =>  total += line[field] , 0);
        },
        open(params){
            if(params.salesOrder) this.form = {...params.salesOrder};
            this.form.date = moment().format("YYYY-MM-DD");
            this.form.validity_date = moment().format("YYYY-MM-DD");
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.openDataFetch();
            this.display = true;
            this.form.customer_id = params.customer_id;
            this.form.customer = params.customer;
        },
        setCustomerName(name) {
            this.form.customer = name;
        },
        async openDataFetch() {
            try {
                if(this.mode.edit) {
                    this.loading.data = true;
                    await this.fetchSalesOrder(this.openParams.id);
                    this.form = JSON.parse(JSON.stringify(this.salesOrder));
                    this.getCustomerData(this.form.customer_id);
                    this.loading.data = false;
                } else this.getDpkData();
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        submit() {
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeSalesOrder(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updateSalesOrder(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }
        },
        openCustomerSearchDialog() {
            this.$refs.customerSearchDialog.open(this.form.customer);
        },
        fetchCustomerName(params) {
            this.form.customer_id = params.id;
            this.form.customer = params.name;
        },
        openSalesOrderItemLineDialog(params){
            this.$refs.salesOrderItemLineDialog.open(params);
            this.selected.salesOrderLineItem = [];
        },
        deleteItemLine(params) {
            let index = this.form.sales_order_item_lines.indexOf(params);
            this.form.sales_order_item_lines.splice(index, 1);
            this.selected.salesOrderLineItem = [];
        },
        lineHandler(line) {
            if (isNull(line.row_id)) this.addNewLine(line);
            else this.updateExistingLine(line)
        },
        addNewLine(line) {
            line.row_id = random(0, 9999);
            line.id = null;
            var index = findIndex(this.form.sales_order_item_lines, o => o.price == line.price && o.item_id == line.item_id);
            if(index == -1) this.pushQuantityToNewLine(line);
            else this.getPermissionToMergeQuantity(line, index);
        },
        getPermissionToMergeQuantity(line, index) {
            this.$refs.decisionDialog.open({target: "addQuantityToExistingLine", title: "Merge Quantity", content: "This item with this price has already been added. Do you want to merge quantities?", payload: {line, index}});
        },
        decisionDialogHandler(params) {
            switch (params.target) {
                case "addQuantityToExistingLine": this.addQuantityToExistingLine(params.payload.line, params.payload.index); break;
                case "closeDialog": this.close(); break;
                default: alert("Error in decision dialog!");
            }
        },
        calculateLineTotals() {
            this.form.sales_order_item_lines.forEach(line => {
                line.subtotal = parseFloat(line.quantity * line.price);
                line.tax = line.is_taxable == true ? line.subtotal * (this.taxPercentage/100): 0;
                line.total = line.subtotal + line.tax;
            });
        },
        calculateTotals() {
            this.tax = this.formatNumber(this.getTotalOf('tax'), 2);
            this.subtotal = this.formatNumber(this.getTotalOf('subtotal'), 2);
            this.total = this.formatCurrency(this.getTotalOf('total'), 2);
        },
        pushQuantityToNewLine(line) {
            this.form.sales_order_item_lines.push(line);
        },
        addQuantityToExistingLine(line, index) {
            this.form.sales_order_item_lines[index]["quantity"] += line.quantity;
        },
        updateExistingLine(line) {
            let existingLine = this.form.sales_order_item_lines.find((each) => each.row_id == line.row_id );
            Object.assign(existingLine, line);
        },
        attemptClose(){
            if(this.form.sales_order_item_lines.length){
                this.$refs.decisionDialog.open({title: this.$t('confirm_title'), content: this.$t('are_you_sure'), target: 'closeDialog'})
            } else {
                this.close();
            }
        },
        // onDecisionDialogSubmit(params){
        //     if(params.target == 'closeDialog') this.close();
        // },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close();
            } 
        },
        formatCurrency(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
        }
    },
    updated() {
        this.$refs.form.validate();
    }
}
</script>